module.exports = __webpack_public_path__ + "static/media/unselected-grey.154529fe.svg";